// extracted by mini-css-extract-plugin
export default {"container":"DotList_container__1svIQ","dot":"DotList_dot__zA39b","selected":"DotList_selected__utnei"};